// extracted by mini-css-extract-plugin
module.exports = {"button":"media_button__nP6qx","scale":"media_scale__9JhkT","animation":"media_animation__DOUWt","hide":"media_hide__7Lno_"};